var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/attachment-thumbs.tsx";
import React from 'react';
import { useDispatch } from 'react-redux';
import { openModal } from 'soapbox/actions/modals';
import Bundle from 'soapbox/features/ui/components/bundle';
import { MediaGallery } from 'soapbox/features/ui/util/async-components';

const AttachmentThumbs = props => {
  const {
    media,
    onClick,
    sensitive
  } = props;
  const dispatch = useDispatch();

  const renderLoading = () => /*#__PURE__*/React.createElement("div", {
    className: "media-gallery--compact",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 31
    }
  });

  const onOpenMedia = (media, index) => dispatch(openModal('MEDIA', {
    media,
    index
  }));

  return /*#__PURE__*/React.createElement("div", {
    className: "attachment-thumbs",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Bundle, {
    fetchComponent: MediaGallery,
    loading: renderLoading,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 7
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    media: media,
    onOpenMedia: onOpenMedia,
    height: 50,
    compact: true,
    sensitive: sensitive,
    visible: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 11
    }
  })), onClick && /*#__PURE__*/React.createElement("div", {
    className: "attachment-thumbs__clickable-region",
    onClick: onClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 9
    }
  }));
};

export default AttachmentThumbs;